import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/Avatar/Avatar.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/Chip/Chip.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/Container/Container.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/Divider/Divider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/Stack/Stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/Typography/Typography.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/teamPage/newPics/1.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/teamPage/newPics/10.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/teamPage/newPics/11.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/teamPage/newPics/12.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/teamPage/newPics/14.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/teamPage/newPics/15.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/teamPage/newPics/16.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/teamPage/newPics/18.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/teamPage/newPics/19.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/teamPage/newPics/2.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/teamPage/newPics/20.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/teamPage/newPics/21.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/teamPage/newPics/22.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/teamPage/newPics/23.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/teamPage/newPics/24.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/teamPage/newPics/25.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/teamPage/newPics/26.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/teamPage/newPics/27.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/teamPage/newPics/28.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/teamPage/newPics/3.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/teamPage/newPics/4.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/teamPage/newPics/5.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/teamPage/newPics/6.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/teamPage/newPics/7.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/teamPage/newPics/8.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/teamPage/newPics/9.webp");
;
import(/* webpackMode: "eager", webpackExports: ["ReplaceArticleUrlWithSlug"] */ "/vercel/path0/src/components/blog/ReplaceArticleUrlWithSlug.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/blog/ShareBar.tsx");
